import React from 'react';
import TeacherMenu from './TeacherMenu';
import StudentMenu from './StudentMenu';
import GuestMenu from './GuestMenu';

const Menu = ({ isTeacher, token }) => (
  <div className="menu-nav">
      {token
        ? isTeacher
          ? <TeacherMenu/>
          : <StudentMenu/>
        : <GuestMenu />}
    </div>
);

export default Menu;
